import { useDispatch } from 'react-redux'
import { pushToast, deleteToast } from '../../stateManager/store/toast/actions'
import { useCallback } from 'react'
import { uuid } from "../../helpers/commonFunction/uuid";

type ToastConfig = {
    type: 'success' | 'error' | 'warning',
    message: string,
    autoClose?: boolean
}

export const useToast = () => {
    const dispatch = useDispatch()

    const raiseToast = useCallback((data: ToastConfig) => {
        const id: string = uuid();
        dispatch(pushToast({ ...data, ...{ id } }))
        if (data.autoClose === undefined || data.autoClose === true) {
            setTimeout(() => {
                dispatch(deleteToast(id));
            }, 5000);
        }
    }, [dispatch])

    const ErrorToast = useCallback((message: string, autoClose?: boolean) => {
        raiseToast({
            type: 'error',
            message,
            autoClose
        })
    },[raiseToast])

    const SuccessToast = useCallback((message: string, autoClose?: boolean) => {
        raiseToast({
            type: 'success',
            message,
            autoClose
        })
    }, [raiseToast])

    const WarningToast = useCallback((message: string, autoClose?: boolean) => {
        raiseToast({
            type: 'warning',
            message,
            autoClose
        })
    }, [raiseToast])

    return {
        ErrorToast,
        SuccessToast,
        WarningToast
    }
}